import { useEffect, useState } from 'react';
import type { DataSnapshot } from '@framework/repository';
import { RefBuilder } from '@framework/repository';
import { RTDBPath } from 'balus-common';
import type { GroupId, InternalPublicWorkspacesJSON } from 'balus-common';

type State = {
  groupId: GroupId;
  values: InternalPublicWorkspacesJSON;
};

/**
 * 指定のグループのグループ内公開ワークスペース設定の一覧を返します。
 * 取得完了までの間は undefined を返します。
 * @param groupId
 * @returns
 */
export const useInternalPublicWorkspaces = (groupId: GroupId): InternalPublicWorkspacesJSON | undefined => {
  const [state, setState] = useState<State | null>(null);

  useEffect(() => {
    const ref = RefBuilder.ref(RTDBPath.Group.internalPublicWorkspacesPath(groupId));
    const callback = (snapshot: DataSnapshot) => {
      setState({ groupId, values: snapshot.val() ?? {} });
    };
    // 読み取りに失敗した場合（権限エラー等）は value callback が呼ばれないため、
    // 空のマップにフォールバックして呼び出し側のローディングゲートが解放されるようにする
    const cancelCallback = () => {
      setState({ groupId, values: {} });
    };

    ref.on('value', callback, cancelCallback);
    return () => ref.off('value', callback);
  }, [groupId]);

  return state?.groupId === groupId ? state.values : undefined;
};
